import i18next from 'i18next';
import merge from "lodash/merge";
import isObject from "lodash/isObject";
import mapKeys from "lodash/mapKeys";

// http://anton.lobovkin.ru/post/37268431457/js-plural
const _plural = (n, f) => {
    let m = n < 0 ? n * -1 : n;
    m %= 100;
    if (m > 10 && m < 20) return f[2];
    m %= 10;
    return f[(m > 1 && m < 5 ? 1 : (m === 1 ? 0 : 2))];
};


//  Special form of the gettext which allows us to translate `nplurals` forms and at the same time pluralize them.
//
//  Example:
//     => pngettext(
//         __("%(days)s day")
//         __("%(days)s days")
//         __("%(days)s days")
//        days, {days})
//
// This example should return a correct form dependent on the given `days`.
const slice = [].slice;

window.pngettext = function() {
    let i, n, named, plurals;
    plurals = 3 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 2) : (i = 0, []), n = arguments[i++], named = arguments[i++];
    if (!isObject(named)) return _plural(named, plurals.concat(n));
    return _plural(n, plurals).format(named);
};

const getConfig = (lang) => ({
    load: 'all',
    fallbackLng: lang,
    lng: lang,
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
    pluralSeparator: false,
    contextSeparator: false
});

const mainLocale = {
    resources: {}
};

const changeLang = (lang, cb) => {
    window._ = window.__ = (string) => i18next.t(string, { defaultValue: string, lngs: [lang] });
    if (cb) cb();
};

const initLang = (lang, json, cb) => {
    if (json) {
        mainLocale.resources[lang] = {
            translation: json
        }
    }

    const i18config = merge({}, getConfig(lang), mainLocale);
    i18next.init(i18config);

    return changeLang(lang, cb);
};

const getDefaultLang = () => {
    // config = require("interface/System")
    // config and config.LOCALE
    return 'en';
};

const setLang = (lang = getDefaultLang(), cb) => {
    if (!lang) return;

    if (!mainLocale.resources[lang]) {
        if (__DEV__) {
            switch (lang) {
                case 'en':
                    require.ensure('../../../i18n/en.json', (function(require) {
                        return initLang(lang, require('../../../i18n/en.json'), cb);
                    }));
                    break;
                case 'ru':
                    require.ensure('../../../i18n/ru.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ru.json'), cb);
                    }));
                    break;
                case 'es':
                    require.ensure('../../../i18n/es.json', (function(require) {
                        return initLang(lang, require('../../../i18n/es.json'), cb);
                    }));
                    break;
                case 'pt':
                    require.ensure('../../../i18n/pt.json', (function(require) {
                        return initLang(lang, require('../../../i18n/pt.json'), cb);
                    }));
                    break;
                case 'de':
                    require.ensure('../../../i18n/de.json', (function(require) {
                        return initLang(lang, require('../../../i18n/de.json'), cb);
                    }));
                    break;
                case 'fr':
                    require.ensure('../../../i18n/fr.json', (function(require) {
                        return initLang(lang, require('../../../i18n/fr.json'), cb);
                    }));
                    break;
                case 'ar':
                    require.ensure('../../../i18n/ar.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ar.json'), cb);
                    }));
                    break;
                case 'tr':
                    require.ensure('../../../i18n/tr.json', (function(require) {
                        return initLang(lang, require('../../../i18n/tr.json'), cb);
                    }));
                    break;
                case 'ja':
                    require.ensure('../../../i18n/ja.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ja.json'), cb);
                    }));
                    break;
                case 'uk':
                    require.ensure('../../../i18n/uk.json', (function(require) {
                        return initLang(lang, require('../../../i18n/uk.json'), cb);
                    }));
                    break;
                default:
                    require.ensure('../../../i18n/en.json', (function(require) {
                        return initLang(lang, require('../../../i18n/en.json'), cb);
                    }));
            }
        } else {
            switch (lang) {
                case 'en':
                    require.ensure('../../../i18n/en.json', (function(require) {
                        return initLang(lang, require('../../../i18n/en.json'), cb);
                    }), "en");
                    break;
                case 'ru':
                    require.ensure('../../../i18n/ru.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ru.json'), cb);
                    }), "ru");
                    break;
                case 'es':
                    require.ensure('../../../i18n/es.json', (function(require) {
                        return initLang(lang, require('../../../i18n/es.json'), cb);
                    }), "es");
                    break;
                case 'pt':
                    require.ensure('../../../i18n/pt.json', (function(require) {
                        return initLang(lang, require('../../../i18n/pt.json'), cb);
                    }), "pt");
                    break;
                case 'de':
                    require.ensure('../../../i18n/de.json', (function(require) {
                        return initLang(lang, require('../../../i18n/de.json'), cb);
                    }), "de");
                    break;
                case 'fr':
                    require.ensure('../../../i18n/fr.json', (function(require) {
                        return initLang(lang, require('../../../i18n/fr.json'), cb);
                    }), "fr");
                    break;
                case 'ar':
                    require.ensure('../../../i18n/ar.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ar.json'), cb);
                    }), "ar");
                    break;
                case 'tr':
                    require.ensure('../../../i18n/tr.json', (function(require) {
                        return initLang(lang, require('../../../i18n/tr.json'), cb);
                    }), "tr");
                    break;
                case 'ja':
                    require.ensure('../../../i18n/ja.json', (function(require) {
                        return initLang(lang, require('../../../i18n/ja.json'), cb);
                    }), "ja");
                    break;
                case 'uk':
                    require.ensure('../../../i18n/uk.json', (function(require) {
                        return initLang(lang, require('../../../i18n/uk.json'), cb);
                    }), "uk");
                    break;
                default:
                    require.ensure('../../../i18n/en.json', (function(require) {
                        return initLang(lang, require('../../../i18n/en.json'), cb);
                    }), "en");
            }
        }
    } else {
        return initLang(lang, null, cb);
    }
};

const REG = {
    DECIMAL: /%\((\w+)\)(\d+)d/g, // "%(name)05d",
    STRING: /%\((\w+)\)s/g // "%(name)s"
};

String.prototype.format = function (o) {
    var output;
    output = this;
    return output.replace(REG.DECIMAL, function(match, name, padding) {
        var len, param;
        if (!(name in o)) {
            return match;
        }
        param = o[name];
        len = parseInt(padding) - param.toString().length;
        if (len < 1) {
            return "" + param;
        }
        return (((function() {
            var i, ref, results;
            results = [];
            for (i = 1, ref = len; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
                results.push("0");
            }
            return results;
        })()).join("")) + param;
    }).replace(REG.STRING, function(match, name) {
        if (!(name in o)) {
            return match;
        }
        return o[name];
    });
};

export default setLang;
